import React from "react";
import { Box, Grid, List, ListItem, Typography } from "@mui/material";

import { specificationDescription } from "@/utils/staticData/productDetails";
import { TabHeading } from "./components";
import { specificationListItemStyles, specificationListStyles } from "./styles";

interface IProps {
  specification: IProductOption[];
}

const SpecificationsTab: React.FC<IProps> = ({ specification }) => {
  return (
    <>
      <TabHeading heading="Details" />

      <Grid container spacing={{ xs: 4 }}>
        <Grid item xs={12} md={6}>
          <List
            disablePadding
            sx={{ ...specificationListStyles, gap: { xs: 1, md: 2 } }}
          >
            {specification.map(({ name, description, id }) => (
              <ListItem
                key={id}
                disablePadding
                sx={specificationListItemStyles}
              >
                <Typography
                  variant="body1"
                  fontSize={"1rem"}
                  component="p"
                  fontWeight={{ xs: 500, md: 600 }}
                >
                  {name} {description}
                </Typography>
              </ListItem>
            ))}
          </List>
        </Grid>

        <Grid item xs={12} md={6}>
          <Box display="flex" flexDirection="column" gap={2}>
            {specificationDescription.map(({ title, data }, index) => (
              <Box key={index}>
                <Typography variant="h6" component="p" mb={2}>
                  {title}
                </Typography>
                <List
                  disablePadding
                  sx={{ ...specificationListStyles, gap: { xs: 1 } }}
                >
                  {data.map((item, index) => (
                    <ListItem
                      key={index}
                      disablePadding
                      sx={specificationListItemStyles}
                    >
                      <Typography
                        variant="body1"
                        fontSize={"1rem"}
                        component="p"
                        fontWeight={{ xs: 500, md: 600 }}
                      >
                        {item}
                      </Typography>
                    </ListItem>
                  ))}
                </List>
              </Box>
            ))}
          </Box>
        </Grid>
      </Grid>
    </>
  );
};

export default SpecificationsTab;
